// extracted by mini-css-extract-plugin
export default {"checkbox":"Checkbox_checkbox__SEHMP","checkbox__text":"Checkbox_checkbox__text__lZtQv","checkbox__text__link":"Checkbox_checkbox__text__link__1FMZB"};